export default "__VITE_ASSET__Bz0H5KKS__"